export default "__VITE_ASSET__B0_0fH6l__"